export type PricingTiers = { max: number; costPerUnit: number }[];

const consumerTiers: PricingTiers = [
  {
    max: 1000,
    costPerUnit: 15,
  },
  {
    max: 5000,
    costPerUnit: 10,
  },
  {
    max: Number.MAX_SAFE_INTEGER,
    costPerUnit: 5,
  },
];
const storageTiers: PricingTiers = [
  {
    max: 1000,
    costPerUnit: 20,
  },
  {
    max: 5000,
    costPerUnit: 15,
  },
  {
    max: Number.MAX_SAFE_INTEGER,
    costPerUnit: 10,
  },
];
const dlBandwidthTiers: PricingTiers = [
  {
    max: Number.MAX_SAFE_INTEGER,
    costPerUnit: 30,
  },
];
const dlRequestTiers: PricingTiers = [
  {
    max: Number.MAX_SAFE_INTEGER,
    costPerUnit: 1 / 1000,
  },
];

export const pricingTiers = {
  consumers: consumerTiers,
  storage: storageTiers,
  dlBandwidth: dlBandwidthTiers,
  dlRequests: dlRequestTiers,
};
